/**
 * Strict env loader. Every value comes from `.env*` — no defaults, no
 * fallbacks. A missing or malformed variable throws at module-load time so
 * a misconfigured build fails fast instead of silently behaving wrong.
 *
 * CRA inlines `process.env.REACT_APP_*` at build time. If you change `.env*`,
 * you must restart `npm start` (or rebuild).
 */

const required = (key) => {
  const value = process.env[key];
  if (value === undefined || value === '') {
    throw new Error(
      `Missing required environment variable: ${key}. Check .env.development / .env.production / .env.staging.`
    );
  }
  return value;
};

const requiredInt = (key) => {
  const raw = required(key);
  const parsed = parseInt(raw, 10);
  if (Number.isNaN(parsed)) {
    throw new Error(
      `Environment variable ${key} must be an integer; got "${raw}".`
    );
  }
  return parsed;
};

export const env = {
  apiUrl: required('REACT_APP_API_URL'),

  oidc: {
    authority: required('REACT_APP_OIDC_AUTHORITY'),
    clientId: required('REACT_APP_OIDC_CLIENT_ID'),
    redirectUri: required('REACT_APP_OIDC_REDIRECT_URI'),
    postLogoutUri: required('REACT_APP_OIDC_POST_LOGOUT_URI'),
    projectId: required('REACT_APP_OIDC_PROJECT_ID'),
    // Optional: pins login to one Zitadel org (branding from the first
    // screen + membership check). Unset locally, set on dev/staging.
    orgId: process.env.REACT_APP_OIDC_ORG_ID || null,
  },

  session: {
    // Seconds in the env file (human-readable). We convert to ms here so
    // every other consumer just uses .ms() and doesn't worry about units.
    idleTimeoutMs: requiredInt('REACT_APP_IDLE_TIMEOUT_S') * 1000,
    maxMs: requiredInt('REACT_APP_SESSION_MAX_S') * 1000,
    warningMs: requiredInt('REACT_APP_IDLE_WARNING_S') * 1000,
  },
};
